module.exports = __webpack_public_path__ + "static/media/slide2.b99301f0.jpg";